export default __webpack_public_path__ + "static/media/ellipses.08d0d3e7.gif";